<div>
  <div class="row">
    <div class="col-md-12">
      <h3 class="float-right mr-3">SERVICE AGREEMENT MANAGEMENT</h3>
      <br />
    </div>
  </div>

  <div class="row animated fadeIn mt-2">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body bg-white border"
          style="border-radius: 15px !important"
        >
          <div class="row">
            <div class="col">
              <label class="label" for="agreementsClientSearch">Client name</label>
              <!-- <input #inputTxt type="text" class="form-control" placeholder="" (click)="resetInput()"> -->
              <app-search-input
                [placeholder]="'Search...'"
                (searchChange)="onSearch($event)"
              ></app-search-input>
            </div>
            <!-- <div class="col-3">
                            <button type="button" class="btn btn-themecolor btn-sm btn-block mt-4 rounded-pill" (click)="searchCustomer(inputTxt.value)">
                               Search
                            </button>
                        </div> -->
            <!-- <div class="col-4">
                            <button type="button" class="btn btn-themecolor btn-sm btn-block mt-4 rounded-pill" (click)="open(newagreementModal, 'lg', null)">
                               Create New agreement
                            </button>
                        </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <!-- -------------------------------------------------- -->
  <!-- <h3>SERVICE AGREETMENTS</h3> -->
  <!-- ** Alerta de No hay Registros y Cargando Datos -->
  <div class="row mt-4 animated fadeIn" *ngIf="projects_arr_Tmp.length == 0">
    <div class="col">
      <div
        class="alert alert-info text-center"
        role="alert"
        *ngIf="message !== 'No Data'"
      >
        <strong>Loading</strong>
        <br />
        <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
        <br />
        <span class="mt-2">Please wait</span>
      </div>

      <div
        class="alert alert-warning text-center"
        role="alert"
        *ngIf="message == 'No Data'"
      >
        <strong>{{ message }}</strong>
        <br />
        <i class="fa fa-warning fa-2x"></i>
      </div>
    </div>
  </div>
  <!-- Wijmo. -->
  <!-- Dentro del layout de filtros -->
  <div class="row align-items-left">
    <div class="col-lg-2">
      <app-custom-button
        [type]="'button'"
        [extraClasses]="'btn btn-default form-control d-inline-block btn-excel custom-btn btn-export-excel'"
        (buttonClick)="exportExcelFile()"
      >
        Export to Excel
      </app-custom-button>
    </div>

    <div class="col-lg-2">
      <input
        #start
        type="date"
        name="start"
        class="form-control"
        [(ngModel)]="filter.start"
        (ngModelChange)="onDateInputsChange()"
      />
    </div>

    <div class="col-lg-2">
      <input
        type="date"
        name="end"
        class="form-control"
        [(ngModel)]="filter.end"
        (ngModelChange)="onDateInputsChange()"
      />
    </div>
    
    <!-- Espacio vacío para empujar el botón a la derecha -->
    <div class="col-lg-4"></div>
    
    <div class="col-lg-2 text-end">
      <app-custom-button 
        [type]="'button'" 
        [disabled]="!hasActiveFilters()"
        (buttonClick)="setAllData()"
      >
        Reset Filters
      </app-custom-button>
    </div>
  </div>
  <!-- Fin fila de filtros -->

  <div class="row animated fadeIn mt-1">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-body bg-white p-0">
          <div class="row">
            <div class="col">
              <div class="grid-panel">
                <app-kite-grid
                  [columnDefs]="columnDefs"
                  [rowData]="pagination_arr"
                  [totalRecords]="totalRecords"
                  [pageSize]="pagination_arr.length || 1"
                  (cellClicked)="onCellClicked($event)"
                ></app-kite-grid>
              </div>
              <div class="total-records">
                Total: <strong>{{ totalRecords }}</strong> Records
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- -------------------------------------------------- -->
</div>

<!-- the popup editor -->
<wj-popup #editModal class="modal-content">
  <div class="modal-header btn-themecolor dialog-title">
    <h4 class="modal-title text-white" id=" modalLabel ">
      UPDATE SERVICE AGREEMENT
    </h4>
    <button
      type="button "
      class="btn-close wj-hide"
      aria-label="Close "
      tabindex="-1"
    ></button>
  </div>

  <div class="modal-body p-4">
    <form
      [formGroup]="popupForm"
      (ngSubmit)="editProject(editModal)"
      autocomplete="off"
      ngNativeValidate
    >
      <div class="row">
        <div class="col-md-12 mb-2">
          <label for="nameoproject" class="label"
            >Client Name</label
          >
          <input
            type="text"
            class="form-control kite-form-control"
            id="name_project"
            placeholder=""
            formControlName="name_client_address"
            disabled
            toUppercase
          />
        </div>
        <div class="col-md-4 mb-2">
          <label for="price" class="label"
            >Price per</label
          >
          <input
            type="text"
            class="form-control"
            id="price"
            placeholder="$"
            formControlName="price"
            (blur)="transformAmount()"
          />
        </div>
        <div class="col-md-4 mb-2">
          <label for="gallons" class="label"
            >Gallons per</label
          >
          <input
            type="number"
            class="form-control"
            id="gallons"
            placeholder=""
            formControlName="gallons"
          />
        </div>
        <div class="col-md-4 mb-2">
          <label for="container_size" class="label"
            >Container Size</label
          >
          <input
            type="number"
            class="form-control"
            id="container_size"
            placeholder=""
            formControlName="container_size"
          />
        </div>
        <div class="col-md-6 mb-2">
          <label for="contact_name" class="label"
            >Contact Name</label
          >
          <input
            type="text"
            class="form-control"
            id="contact_name"
            placeholder=""
            formControlName="contact_name"
            toUppercase
          />
        </div>
        <div class="col-md-6 mb-2">
          <label for="sales_person" class="label"
            >Sales Person</label
          >
          <input
            type="text"
            class="form-control"
            id="sales_person"
            placeholder=""
            formControlName="sales_person"
            disabled
            toUppercase
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label for="floatingTextarea" class="label"
            >Special Requirements / Directions</label
          >
          <textarea
            class="form-control"
            placeholder=""
            id="floatingTextarea"
            style="height: 100px"
            formControlName="special_requirements"
            oninput="this.value = this.value.toUpperCase();"
          ></textarea>
        </div>
      </div>
      <div class="row mt-2">
        <div class="modal-footer mx-auto">
          <div class="col-sm"></div>
          <div class="col-sm"></div>
          <div class="col-sm">
            <button
              type="submit"
              class="btn btn-themecolor btn-block kite-button"
            >
              UPDATE
            </button>
          </div>
          <div class="col-sm">
            <button
              type="button"
              class="btn btn-block kite-button-cancel wj-hide"
              aria-label="Close"
              tabindex="-1"
            >
              CANCEL
            </button>
          </div>
          <div class="col-sm"></div>
          <div class="col-sm"></div>
        </div>
      </div>
    </form>
  </div>
</wj-popup>

<!-- MODAL DELETE -->
<ng-template #deleteModal let-modal>
  <div class="modal-header btn-themecolor dialog-title">
    <h4 class="modal-title text-white" id=" modalLabel">
      DELETE SERVICE AGREEMENT
    </h4>
    <button
      type="button "
      class="btn-close"
      aria-label="Close "
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div class="kite-del-line">
      <h2 class="mr-2 kite-delete-label">
        Do you want to Delete the "Services Agreement" document associated to
        <strong>{{ project.name_project | uppercase }}?</strong>
      </h2>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col text-center">
        <button
          type="button"
          class="btn kite-btn-close"
          data-dismiss="modal"
          (click)="modal.dismiss('close')"
        >
          Close
        </button>
      </div>
      <div class="col text-center">
        <button
          type="button"
          class="btn kite-button-cancel"
          (click)="deleteProject(modal, project)"
        >
          Yes, Delete it!
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- MODAL INFO -->
<ng-template #infoModal let-modal>
  <div class="modal-header btn-themecolor dialog-title">
    <h4 class="modal-title text-white" id=" modalLabel">
      SERVICES AGREEMENT INFORMATION
    </h4>
    <button
      type="button "
      class="btn-close"
      aria-label="Close "
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div style="margin: 2% !important">
      <div class="row kite-border-head">
        <div class="col-lg-3 col-md-3">
          <label class="label">CLIENT ID</label>
          <p class="kite-info-id kite-id-form-control">
            {{ project.ident_GUI | uppercase }}
          </p>
        </div>
        <div class="col-lg-9 col-md-9">
          <label class="label">RESTAURANT</label>
          <p class="kite-info-p">
            {{ project.client.name_client_address | uppercase }}
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <label class="label">ADDRESS</label>
          <p class="kite-info-p">{{ project.client.address | uppercase }}</p>
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="label">CITY</label>
          <p class="kite-info-p">{{ project.client.city | uppercase }}</p>
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="label">ZIP CODE</label>
          <p class="kite-info-p">{{ project.client.zip_code | uppercase }}</p>
        </div>
        <div class="col-lg-4 col-md-12">
          <label class="label">CONTACT NAME</label>
          <p class="kite-info-p">
            {{ project.contact_name || "UNDEFINED" | uppercase }}
          </p>
        </div>
        <div class="col-lg-4 col-md-4">
          <label class="label">PHONE NUMBER</label>
          <p class="kite-info-p">{{ project.client.phone || "UNDEFINED" }}</p>
        </div>
        <div class="col-lg-4 col-md-8">
          <label class="label">EMAIL</label>
          <p class="kite-info-p">{{ project.client.email || "UNDEFINED" }}</p>
        </div>
      </div>
    </div>

    <div class="row" style="padding: 2%">
      <div class="col-lg-3 col-md-8">
        <label class="label">Signed Date</label>
        <p class="kite-read-p">{{ project.created_at | date }}</p>
      </div>
      <div class="col-lg-3 col-md-4">
        <label class="label">Price per Gallon</label>
        <p class="kite-read-p">{{ project.price }}</p>
      </div>
      <div class="col-lg-3 col-md-6">
        <label class="label">Gallons per Week</label>
        <p class="kite-read-p">{{ project.gallons | number }}</p>
      </div>
      <div class="col-lg-3 col-md-6">
        <label class="label">Container Size</label>
        <p class="kite-read-p">{{ project.container_size | number }}</p>
      </div>
    </div>
    <div style="margin: 1% 2% 1% 2% !important">
      <div class="row">
        <div class="col-sm">
          <label class="label">SPECIAL REQUERIMENTS</label>
          <p class="kite-sa-req">{{ project.special_requirements[0] }}</p>
        </div>
      </div>
    </div>
    <div class="row" style="padding: 2%">
      <div class="col-sm bd-safilesupport">
        <p class="lb-safilesupport">
          A Services Agreement Support File is a digital file that supports a
          Services Agreement and can be used as an alternative to signing an
          agreement. It guarantees that the services agreement has not been
          signed physically, but is instead supported by an attached digital
          document. This file is available in PDF or image format. <br />If you
          want to view the attachment file, simply click on the file name.
        </p>
        <table class="tb-safilesupport">
          <thead>
            <tr>
              <th>
                <p *ngIf="project.agreement.has_support; else noSupport">
                  <a
                    href="https://kite-pro.com/back/uploads/business/agreements/sa-supports/{{
                      project.agreement.year
                    }}/{{
                      project.agreement.month > 9
                        ? project.agreement.month
                        : 0 + project.agreement.month
                    }}/files/{{ project.agreement.file }}"
                    target="_blank"
                  >
                    {{ project.agreement.file }}
                  </a>
                </p>
                <ng-template #noSupport>
                  <p class="sa-nosupport">No Services Agreement Support File</p>
                </ng-template>
              </th>
            </tr>
            <!-- <tr>
                            <th>
                                <p *ngIf="project.agreement.zoho.file_support else noSupport">
                                    <a href="https://kite-pro.com/back/{{project.agreement.zoho.file_support}}" target="_blank">
                                        KITE-{{project.agreement.zoho.request_id}}
                                    </a>
                                </p>
                            </th>
                          </tr> -->
          </thead>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col text-center">
          <button
            type="button"
            class="btn kite-btn-close"
            data-dismiss="modal"
            (click)="modal.dismiss('close')"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
